// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "3.70.0/styles/main.bundle.css";
	// return url for filenames based on template
	return "3.70.0/styles/" + "videojs" + ".chunk.css?" + "d9dcd5ecbf49f3296bce" + "";
};